export const translation = {
  'nav.home': 'Home',
  'nav.structure': 'Structure',
  'nav.modalities': 'Modalities',
  'nav.plans': 'Plans',
  'nav.store': 'Store',
  'nav.schedules': 'Schedules',
  'nav.location': 'Location',
  'nav.contact': 'Contact',
  'nav.whatsapp': 'WhatsApp',
  'nav.mainNavigation': 'Main navigation',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',

  'footer.modalities': 'Modalities',
  'footer.institutional': 'About',
  'footer.contact': 'Contact',
  'footer.newsletter': 'Get news and special schedules',
  'footer.newsletterBtn': 'Subscribe',
  'footer.emailPlaceholder': 'Your email',
  'footer.emailLabel': 'Your email to receive news',
  'footer.rights': 'All rights reserved',
  'footer.slogan': 'Beach strength, real training. Cumbuco - CE',
  'footer.description': 'Gym in Cumbuco, Caucaia - CE. Real training near the beach.',

  'footer.modalityWeightTraining': 'Weight Training',
  'footer.modalityCrossTraining': 'Cross Training',
  'footer.modalityFunctional': 'Functional Circuit',
  'footer.modalityMuayThai': 'Muay Thai',
  'footer.storeLink': 'Fitness Store',

  'home.store.marqueeFashion': 'Fitness Fashion',
  'home.store.marqueeSupplements': 'Supplements',
  'home.store.marqueeAccessories': 'Accessories',
  'home.store.marqueeTraining': 'Training',
  'home.store.marqueeBodybuilding': 'Bodybuilding',
  'home.store.marqueePerformance': 'Performance',

  'store.category.fashion': 'Fitness Fashion',
  'store.category.supplements': 'Supplements',
  'store.category.accessories': 'Accessories',

  'store.product.prod-1.name': 'Premium Fitness Leggings',
  'store.product.prod-2.name': 'Dry-Fit Essential Top',
  'store.product.prod-3.name': 'Whey Protein 900g',
  'store.product.prod-4.name': 'Creatine Monohydrate 300g',
  'store.product.prod-5.name': 'Shaker Bottle 700ml',
  'store.product.prod-6.name': 'Premium Yoga Mat',
  'store.product.prod-7.name': 'Training Gloves',
  'store.product.prod-8.name': "Men's Dry-Fit T-Shirt",

  'home.hero.videoTitle': 'Top Gym Cumbuco - Real training near the beach',
  'home.hero.videoAriaLabel': 'Video of Top Gym Cumbuco gym showing the facilities and workouts',

  'structure.musculacao.title': 'Weight Training Area',
  'structure.musculacao.description': 'Equipment and free weights for a complete workout',
  'structure.pesos-livres.title': 'Free Weights',
  'structure.pesos-livres.description': 'Dumbbells, kettlebells, plates and bars',
  'structure.cross-training.title': 'Cross Training Space',
  'structure.cross-training.description': 'Area for functional training and circuit',
  'structure.muay-thai.title': 'Muay Thai and Jiu Jitsu Area',
  'structure.muay-thai.description': 'Ring and mats for martial arts training',
  'structure.aulas.title': 'Class Space',
  'structure.aulas.description': 'Room for group classes and functional training',
  'structure.recepcao.title': 'Reception',
  'structure.recepcao.description': 'Personalized and welcoming service',

  'modality.musculacao.name': 'Weight Training',
  'modality.musculacao.description': 'Workouts for strength, health, conditioning and physical evolution with equipment and free weights.',
  'modality.musculacao.audience': 'For all levels and goals',
  'modality.cross-training.name': 'Cross Training',
  'modality.cross-training.description': 'Varied and intense workouts that combine different modalities for maximum results.',
  'modality.cross-training.audience': 'For those seeking challenge and variety',
  'modality.circuito-funcional.name': 'Functional Circuit',
  'modality.circuito-funcional.description': 'Dynamic classes with natural movements that improve endurance, agility and coordination.',
  'modality.circuito-funcional.audience': 'Ideal for overall conditioning',
  'modality.muay-thai.name': 'Muay Thai and Jiu Jitsu',
  'modality.muay-thai.description': 'Martial arts that develop technique, physical conditioning, self-defense and self-confidence.',
  'modality.muay-thai.audience': 'For beginners and practitioners of both modalities',

  'testimonial.carlos.name': 'Carlos M.',
  'testimonial.carlos.location': 'Cumbuco, Brazil',
  'testimonial.carlos.text': 'Great equipment, community vibe and qualified staff. The perfect gym for the size of the village.',
  'testimonial.ana.name': 'Ana Paula R.',
  'testimonial.ana.location': 'Caucaia, Brazil',
  'testimonial.ana.text': 'I have been training for 6 months and the evolution is remarkable. Attentive teachers and quality equipment.',
  'testimonial.pedro.name': 'Pedro S.',
  'testimonial.pedro.location': 'Fortaleza, Brazil',
  'testimonial.pedro.text': 'I spend seasons in Cumbuco and Top Gym is my mandatory stop. Great structure near the beach.',

  'cta.whatsapp': 'Message on WhatsApp',
  'cta.map': 'View location',
  'cta.seeMore': 'See more',
  'cta.knowMore': 'Learn more',
  'cta.heading': 'GET IN TOUCH WITH TOP GYM',

  'mobile.whatsapp': 'WhatsApp',
  'mobile.directions': 'Directions',

  'page.estrutura.title': 'STRUCTURE',
  'page.estrutura.highlight': 'COMPLETE',
  'page.estrutura.subtitle': 'Discover our structure designed for all types of training.',

  'page.modalidades.title': 'MODALITIES',
  'page.modalidades.subtitle': 'Weight training, cross training, functional circuit and muay thai for all levels.',
  'page.modalidades.tag': 'Most Popular',

  'page.horarios.title': 'SCHEDULES',
  'page.horarios.subtitle': 'Opening hours and classes to plan your workout.',
  'page.horarios.weekday': 'Monday to Friday',
  'page.horarios.weekdayHours': '6 AM to 10 PM',
  'page.horarios.saturday': 'Saturday',
  'page.horarios.saturdayHours': '8 AM to 12 PM',
  'page.horarios.sunday': 'Sunday',
  'page.horarios.sundayHours': 'Closed',
  'page.horarios.classSchedule': 'Class Schedule',

  'page.localizacao.title': 'LOCATION',
  'page.localizacao.subtitle': 'Come train with us in Cumbuco, just minutes from the beach.',
  'page.localizacao.addressLabel': 'Address',
  'page.localizacao.referenceLabel': 'Reference',
  'page.localizacao.referenceText': 'Located in Cumbuco, just minutes from the beach',
  'page.localizacao.openMap': 'Open in Google Maps',

  'page.contato.title': 'CONTACT',
  'page.contato.subtitle': 'Get in touch with Top Gym and check plans, schedules and available modalities.',
  'page.contato.contactUs': 'Contact Us',
  'page.contato.whatsapp': 'WhatsApp',
  'page.contato.email': 'Email',
  'page.contato.address': 'Address',
  'page.contato.instagram': 'Instagram',
  'page.contato.hours': 'Hours',
  'page.contato.weekday': 'Mon-Fri:',
  'page.contato.saturday': 'Saturday:',
  'page.contato.sunday': 'Sunday:',
  'page.contato.formTitle': 'I want to talk to Top Gym',
  'page.contato.formSubtitle': 'Fill in your details and we will contact you.',
  'page.contato.name': 'Name',
  'page.contato.namePlaceholder': 'Your name',
  'page.contato.phone': 'Phone',
  'page.contato.phonePlaceholder': '(85) 99999-9999',
  'page.contato.goal': 'Goal',
  'page.contato.goalPlaceholder': 'Tell us your goal...',
  'page.contato.submit': 'I want to talk to Top Gym',
  'page.contato.sentTitle': 'WhatsApp opened!',
  'page.contato.sentText': 'Review the message in WhatsApp and tap Send.',
  'page.contato.sentBtn': 'WhatsApp opened! Review and send the message.',
  'page.contato.qrTitle': 'Chat on WhatsApp',
  'page.contato.qrSubtitle': 'Point your phone camera',

  'seo.home.title': 'Top Gym - Premium Gym in Cumbuco',
  'seo.home.description': 'Top Gym Cumbuco is a gym for those who want to train with structure, guidance and international energy. Whether you are a resident, visitor or someone spending a season in Cumbuco, your workout continues here.',
  'seo.home.keywords': 'gym, fitness, bodybuilding, workout, training in Cumbuco',

  'seo.estrutura.title': 'Top Gym Cumbuco Structure & Facilities',
  'seo.estrutura.description': 'Discover the complete structure of Top Gym Cumbuco. Modern equipment, space for weight training, functional training and martial arts.',
  'seo.estrutura.keywords': 'gym, bodybuilding, functional, martial arts, fitness, training',

  'seo.modalidades.title': 'Training Modalities at Top Gym Cumbuco',
  'seo.modalidades.description': 'Weight training, cross training, functional circuit and muay thai. Workouts for all levels at Top Gym Cumbuco.',
  'seo.modalidades.keywords': 'gym, bodybuilding, functional, martial arts, fitness, training',

  'seo.horarios.title': 'Class Schedule & Opening Hours - Top Gym Cumbuco',
  'seo.horarios.description': 'Opening hours and class schedule at Top Gym Cumbuco. Plan your workout from Monday to Saturday.',
  'seo.horarios.keywords': 'gym, schedule, classes, bodybuilding, fitness, training',

  'seo.localizacao.title': 'Top Gym Cumbuco Location - Cumbuco, Caucaia',
  'seo.localizacao.description': 'Come train with us in Cumbuco, just minutes from the beach. Address and directions to Top Gym Cumbuco.',
  'seo.localizacao.keywords': 'gym Cumbuco, gym Caucaia, bodybuilding Cumbuco, fitness Ceará',

  'seo.contato.title': 'Contact Top Gym Cumbuco - Get in Touch',
  'seo.contato.description': 'Get in touch with Top Gym Cumbuco. Ask about plans, schedules and available modalities.',
  'seo.contato.keywords': 'gym, contact, WhatsApp, bodybuilding, fitness, training',

  'page.notFound.documentTitle': 'Page not found | Top Gym Cumbuco',
  'page.notFound.heading': 'Page not found',
  'page.notFound.backBtn': 'Back to home',
};
